export default __webpack_public_path__ + "static/media/1.65c683a3.jpg";